import { render, staticRenderFns } from "./KIWToolbarMenu.vue?vue&type=template&id=188883c4&scoped=true"
import script from "./KIWToolbarMenu.vue?vue&type=script&lang=js"
export * from "./KIWToolbarMenu.vue?vue&type=script&lang=js"
import style0 from "./KIWToolbarMenu.vue?vue&type=style&index=0&id=188883c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188883c4",
  null
  
)

export default component.exports